import axios from 'axios'

class RelatoriosApiClient {

    async gerarRelatorioFichaPaciente(dados) {
        axios({
            url: `/relatorios/fichaPaciente/${dados.pacienteId}`,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            if (dados.baixar) {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]))
                var fileLink = document.createElement('a')
                fileLink.href = fileURL
                fileLink.setAttribute('download', `FichaPaciente-${dados.nomePaciente}.pdf`)
                document.body.appendChild(fileLink)
                fileLink.click()
            } else {
                var blob = new Blob([response.data], {type: 'application/pdf'})
                var blobURL = URL.createObjectURL(blob)
                window.open(blobURL)
            }
        })
    }

    async gerarRelatorioCobranca(dados) {
        let pacienteId = dados.pacienteId ? `&pacienteId=${dados.pacienteId}` : ''
        let dataInicio = dados.dataInicio ? `&dataInicio=${dados.dataInicio}` : ''
        let dataFim = dados.dataFim ? `&dataFim=${dados.dataFim}` : ''
        axios({
            url: `/relatorios/cobrancas/?tipoPeriodo=${dados.tipoPeriodo}&statusCobranca=${dados.statusCobranca}` + pacienteId + dataInicio + dataFim,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            if (dados.baixar) {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]))
                var fileLink = document.createElement('a')
                fileLink.href = fileURL
                fileLink.setAttribute('download', 'Relatório de Cobranças.pdf')
                document.body.appendChild(fileLink)
                fileLink.click()
            } else {
                var blob = new Blob([response.data], {type: 'application/pdf'})
                var blobURL = URL.createObjectURL(blob)
                window.open(blobURL)
            }
        })
    }

    async gerarRelatorioPacientes(dados) {
        let ultimaVisita = `ultimaVisita=${dados.filtros.ultimaVisita}`
        let ortodontia = dados.filtros.ortodontia ? `&ortodontia=${dados.filtros.ortodontia}` : ''
        let implante = dados.filtros.implante ? `&implante=${dados.filtros.implante}` : ''
        let municipioId = dados.filtros.municipioId ? `&municipioId=${dados.filtros.municipioId}` : ''
        let estadoId = dados.filtros.estadoId ? `&estadoId=${dados.filtros.estadoId}` : ''
        let sexo = dados.filtros.sexo ? `&sexo=${dados.filtros.sexo}` : ''
        let mesAniversario = dados.filtros.mesAniversario ? `&mesAniversario=${dados.filtros.mesAniversario}` : ''

        axios({
            url: '/relatorios/paciente/?' + ultimaVisita + ortodontia + implante + municipioId + estadoId + sexo + mesAniversario,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            if (dados.baixar) {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]))
                var fileLink = document.createElement('a')
                fileLink.href = fileURL
                fileLink.setAttribute('download', 'Relatório de Pacientes.pdf')
                document.body.appendChild(fileLink)
                fileLink.click()
            } else {
                var blob = new Blob([response.data], {type: 'application/pdf'})
                var blobURL = URL.createObjectURL(blob)
                window.open(blobURL)
            }
        })
    }

    async gerarRelatorioPagamento(dados) {
        let pacienteId = dados.pacienteId ? `&pacienteId=${dados.pacienteId}` : ''
        let dataInicio = dados.dataInicio ? `&dataInicio=${dados.dataInicio}` : ''
        let dataFim = dados.dataFim ? `&dataFim=${dados.dataFim}` : ''
        axios({
            url: `/relatorios/pagamentos/?formaPagamento=${dados.formaPagamento}` + pacienteId + dataInicio + dataFim,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            if (dados.baixar) {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]))
                var fileLink = document.createElement('a')
                fileLink.href = fileURL
                fileLink.setAttribute('download', 'Relatório de Pagamentos.pdf')
                document.body.appendChild(fileLink)
                fileLink.click()
            } else {
                var blob = new Blob([response.data], {type: 'application/pdf'})
                var blobURL = URL.createObjectURL(blob)
                window.open(blobURL)
            }
        })
    }

    async gerarRelatorioOrcamentos(dados) {
        return axios.post('/relatorios/orcamentos', dados)
    }

    async gerarRelatorioOrcamentoFinalizado(dados) {
        axios({
            url: `/relatorios/orcamentoFinalizado/${dados.orcamentoId}`,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            if (dados.baixar) {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]))
                var fileLink = document.createElement('a')
                fileLink.href = fileURL
                fileLink.setAttribute('download', `Orcamento-${dados.codigo}.pdf`)
                document.body.appendChild(fileLink)
                fileLink.click()
            } else {
                var blob = new Blob([response.data], {type: 'application/pdf'})
                var blobURL = URL.createObjectURL(blob)
                window.open(blobURL)
            }
        })
    }
}

export default new RelatoriosApiClient()